<template>
    <el-input
        :placeholder="defaultValue"
        :disabled="disabled"
        v-bind:value="testValue"
        v-on:input="saveValue"
        class="inputWithSelect"
        type="number"
    >
        <p
            v-if="!noChangeDetected"
            slot="suffix"
            class="default"
        >
            {{ defaultValue }}
        </p>
        <el-button
            slot="prepend"
            class="resetButton"
            style="width: 50px;"
            @click="resetAll"
        >
            <i
                v-if="noChangeDetected"
                class="el-icon-check"
            ></i>
            <i
                v-else
                class="el-icon-upload2"
            ></i>
        </el-button>
    </el-input>
</template>

<script>

export default {

    props: {
        value:{
            type: Number,
            required: false,
            default: 0
        },
        defaultValue: {
            type: [Number],
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        return {
            testValue: undefined,
        }
    },
    computed: {
        currentValue() {
            return this.noChangeDetected ? '' : this.userOverrideValue;
        },

        noChangeDetected (){
            if(this.value === this.defaultValue){
                return true;
            }
            return false;
        },
    },

    methods: {
        resetAll() {
            this.saveValue(this.defaultValue);
        },
        saveValue($event){
            this.testValue = $event
            if(this.testValue === this.defaultValue){
                this.testValue = undefined;
            }
            this.$emit('input', parseFloat($event))
        }
    },
};


</script>

<style lang="less">
@import "../../less/variables.less";
.inputWithSelect {
    max-width: 200px;
    input:focus {
        border-color: @color-1;
    }
    .resetButton:hover {
        color: @color-1;
    }
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

}
.resetButton{
    padding: 12px;
    .el-icon-upload2 {
        transform: rotate(-90deg);
    }
}

.default {
  text-decoration: line-through;
  line-height: 40px;
  margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/partials/customInput.vue